import { CheckCircle, AlertCircle, Info, AlertTriangle, X } from 'lucide-react';
import { toast } from 'sonner';

export type ToastVariant = 'success' | 'alert' | 'warning' | 'info' | 'default';

interface ToastMessageProps {
  id: string | number;
  variant?: ToastVariant;
  message: string;
  details?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function ToastMessage({ id, variant = 'default', message, details, action }: ToastMessageProps) {
  const getIcon = () => {
    switch (variant) {
      case 'success':
        return <CheckCircle />;
      case 'alert':
        return <AlertCircle />;
      case 'warning':
        return <AlertTriangle />;
      case 'info':
        return <Info />;
      default:
        return null;
    }
  };

  return (
    <div className="toast-custom-item" data-variant={variant}>
      <div className="toast-icon">{getIcon()}</div>
      <div className="toast-content">
        <p className="toast-message">{message}</p>
        {details && <p className="toast-details">{details}</p>}
      </div>
      {action && (
        <button className="toast-action" onClick={action.onClick}>
          {action.label}
        </button>
      )}
      <button className="toast-close-button" onClick={() => toast.dismiss(id)} aria-label="Close">
        <X size={18} />
      </button>
    </div>
  );
}
